// Versión actual de la aplicación
// Debe coincidir con la versión en package.json
export const APP_VERSION = '1.0.0';
